import * as api from '../api/workitemsearch';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

const namespace = 'QUEUE';

export const FETCH_SEARCH_RESULT_CONFIG = createRequestTypes(
  `${namespace}/FETCH_SEARCH_RESULT_CONFIG`,
);

export const fetchSearchResultConfig = makeApiActionCreatorV3(
  api.fetchSearchResultConfig,
  FETCH_SEARCH_RESULT_CONFIG[START],
  FETCH_SEARCH_RESULT_CONFIG[SUCCESS],
  FETCH_SEARCH_RESULT_CONFIG[ERROR],
);

export const SEARCH_WORK_ITEM = createRequestTypes(
  `${namespace}/SEARCH_WORK_ITEM`,
);

export const searchWorkItem = makeApiActionCreatorV3(
  api.searchWorkItem,
  SEARCH_WORK_ITEM[START],
  SEARCH_WORK_ITEM[SUCCESS],
  SEARCH_WORK_ITEM[ERROR],
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const DELETE_WORK_ITEM = createRequestTypes(
  `${namespace}/DELESE_WORK_ITEM`,
);

export const deleteWorkItem = makeApiActionCreatorV3(
  api.deleteWorkItem,
  DELETE_WORK_ITEM[START],
  DELETE_WORK_ITEM[SUCCESS],
  DELETE_WORK_ITEM[ERROR],
);

export const DELETE_WORK_ITEMS = createRequestTypes(
  `${namespace}/DELETE_WORK_ITEMS`,
);

export const deleteWorkItems = makeApiActionCreatorV3(
  api.deleteWorkItems,
  DELETE_WORK_ITEMS[START],
  DELETE_WORK_ITEMS[SUCCESS],
  DELETE_WORK_ITEMS[ERROR],
);
